"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toAntDataSource(items) {
    return items.map((row, index) => (Object.assign({ key: index }, row)));
}
function getAntdSort(fieldName, sort) {
    if (sort === null) {
        return undefined;
    }
    if (fieldName !== sort.fieldName) {
        return undefined;
    }
    return sort.direction === 'ASC' ? 'ascend' : 'descend';
}
function toAntColumns(fields, sort) {
    const columns = fields.map((field, index) => (Object.assign({}, field.options, { title: field.label, dataIndex: field.index || field.name, sortOrder: getAntdSort(field.name, sort), sorter: field.isSortable, render: (data) => field.formatter(data) })));
    return columns;
}
function toAntPagination(pagination, config = {}) {
    return Object.assign({ pageSize: pagination.length, current: pagination.displayIndex, total: pagination.totalLength, hideOnSinglePage: true }, config);
}
exports.AndTableHelpers = {
    toAntDataSource,
    toAntColumns,
    toAntPagination
};
//# sourceMappingURL=AndTableHelpers.js.map